import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import { ModalButton } from 'baseui/modal'
import { ArrowRight } from 'baseui/icon'
import { Spinner } from 'baseui/spinner'
import { useTranslation } from 'react-i18next'
import { useStyletron } from 'baseui'
import usePceSearchV2 from './usePceSearchV2'
import useRetrievePCEsV2 from './useRetrievePCEsV2'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import AddressSelect from '@/containers/SubscriptionFormPageNew/Components/shared/AddressSelect/AddressSelect'
import {
  SearchModalBody,
  SearchModalFooter,
} from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/styled-components'
import useMeterSearchField from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/useMeterSearchField'
import { pulseModalButtonOverrides } from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/styled-components'

const PceSearchForm = () => {
  const { t } = useTranslation()
  const [css, theme] = useStyletron()
  const { isPulse, fieldText } = useMeterSearchField()
  const {
    getAddress,
    getOccupant,
    getSerialNumber,
    getStreetNumber,
    getStreetName,
    isFormFilled,
    isCustomerNamed,
    isNameTooShort,
    holderLabelKey,
    isLoading,
    updatePceConfigData,
    updateAddressHandler,
  } = usePceSearchV2()
  const { searchPCEs } = useRetrievePCEsV2()

  return (
    <>
      <SearchModalBody $pulse={isPulse}>
        <AddressSelect
          currentValue={getAddress}
          onChange={updateAddressHandler}
          disabled={isLoading}
          required={isPulse}
          {...fieldText('subscriptionTools:pce_search.fields.address')}
        />
        <div
          className={css({
            display: 'flex',
            gap: '1rem',
            alignItems: 'center',
            marginBottom: '1rem',
          })}
        >
          <div className={css({ flex: '1 1 30%' })}>
            <SDInput
              currentValue={getStreetNumber}
              outerOnchange={value => updatePceConfigData({ address: { ...getAddress, streetNumber: value } })}
              {...fieldText('subscriptionForm:address_module.street_number')}
            />
          </div>
          <div className={css({ flex: '1 1 70%' })}>
            <SDInput
              currentValue={getStreetName}
              outerOnchange={value => updatePceConfigData({ address: { ...getAddress, streetName: value } })}
              {...fieldText('subscriptionForm:address_module.street_name')}
            />
          </div>
        </div>

        <SDFormControl plainLabel>
          <SDInput
            label={t(holderLabelKey)}
            currentValue={getOccupant}
            outerOnchange={value => updatePceConfigData({ occupant: value || '' })}
            disabled={isLoading}
          />
        </SDFormControl>

        <SDFormControl plainLabel>
          <SDInput
            {...fieldText('subscriptionTools:pce_search.fields.serial_number')}
            currentValue={getSerialNumber}
            outerOnchange={value => updatePceConfigData({ serialNumber: value || '' })}
            disabled={isLoading}
          />
        </SDFormControl>
        <p
          id='pce-search-customer-name-required'
          hidden={isCustomerNamed}
          className={css({ margin: 0, color: theme.colors.negative })}
        >
          {t('subscriptionTools:pce_search.customer_name_required')}
        </p>
        <p
          id='pce-search-name-too-short'
          hidden={!isNameTooShort}
          className={css({ margin: 0, color: theme.colors.negative })}
        >
          {t('subscriptionTools:pce_search.blocking.name_too_short')}
        </p>
      </SearchModalBody>

      <SearchModalFooter $pulse={isPulse}>
        <ModalButton
          id='button-start-search'
          overrides={isPulse ? pulseModalButtonOverrides : undefined}
          endEnhancer={() => <ArrowRight size={isPulse ? 18 : 24} />}
          disabled={!isFormFilled || isLoading}
          onClick={searchPCEs}
        >
          {t('subscriptionTools:pce_search.start_search')}
        </ModalButton>
        {isLoading && <Spinner size={24} />}
      </SearchModalFooter>
    </>
  )
}

export default PceSearchForm
